<div class="global-cell-renderer" (click)="$event.stopPropagation()" style="padding-top: 2px;">
    <mydocma-custom-mat-icon [iconName]="'_warning-filled'" style="color: orange" *ngIf="value == syncStatus.NotSync">
    </mydocma-custom-mat-icon>
    <mydocma-custom-mat-icon [iconName]="'_high-priority'" style="color: red" *ngIf="value == syncStatus.Error">
    </mydocma-custom-mat-icon>
</div>
